import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { State } from '../../../typings/state';
import { TDispatchProps, TStateProps } from '../../../typings/utils';
import { CanvasAction } from '../../common/actions';
import { Page } from '../../common/typings';
import {
    closePreviewsModal,
    createGraphicCreative,
    cropModalClose,
    initAdaptiveCreative,
    optionChange,
    returnSelect,
    saveName,
    setSmartCenter,
    showPreviewsModal,
    submitPreviewsModal,
    toggleOptionGroupVisibility
} from '../actions';
import { selectAdaptiveCreativeState } from '../selectors';

import { AddAdaptiveCreative, AddAdaptiveCreativeProps } from './AddAdaptiveCreative';
import { smartCenterEnabled } from './helpers';
import { selectPcodeData } from './selectors';

type StateProps = TStateProps<AddAdaptiveCreativeProps>;
type DispatchProps = TDispatchProps<AddAdaptiveCreativeProps, OwnProps>;
type OwnProps = {
    onCancel: () => void;
};

const mapStateToProps = (state: State): StateProps => {
    const addCreativeState = selectAdaptiveCreativeState(state.canvasEditor.canvas.addCreative);
    const ideaId = state.canvasEditor.canvas.commonData.ideaId;
    const {
        isLoading,
        isSaving,
        creativeOptions,
        returnPage,
        error,
        previewsModalVisible,
        item,
        previewItems,
        ideaFilesCropped,
        createPressed
    } = addCreativeState;

    return {
        isLoading,
        isSaving,
        creativeOptions,
        returnPage,
        error,
        previewsModalVisible,
        recropEnabled: smartCenterEnabled(addCreativeState),
        item,
        previewItems,
        pcodeData: selectPcodeData(addCreativeState),
        createPressed: Boolean(ideaId && !ideaFilesCropped && createPressed)
    };
};

const mapDispatchToProps = (dispatch: Dispatch<CanvasAction>): DispatchProps => {
    return {
        onOptionChange: (groupName: string, name: string, value: string): void => {
            dispatch(optionChange(groupName, name, value));
        },
        onGroupVisibleChange: (groupName: string): void => {
            dispatch(toggleOptionGroupVisibility(groupName));
        },
        onSaveName: (name: string): void => {
            dispatch(saveName(name));
        },
        onSave: (): void => {
            dispatch(createGraphicCreative());
        },
        showPreviewsModal: (): void => {
            dispatch(showPreviewsModal(true));
        },
        cancelPreviewsModal: (): void => {
            dispatch(setSmartCenter());
        },
        closePreviewsModal: (): void => {
            dispatch(closePreviewsModal());
        },
        submitPreviewsModal: (continueEdit?: boolean): void => {
            dispatch(submitPreviewsModal(continueEdit));
        },
        init: (): void => {
            dispatch(initAdaptiveCreative());
        },
        smartCenterClose: (): void => {
            dispatch(cropModalClose());
        },
        onReturnClick: (page?: Page): void => {
            dispatch(returnSelect(page));
        }
    };
};

export const AddAdaptiveCreativeContainer = connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(AddAdaptiveCreative);
